import { Injectable, inject } from '@angular/core';
import { ServerStateService, ApplicationStateService, ProductsStateService } from './index';

/**
 * Service responsible for cleaning all application states
 * Used primarily during login to ensure a clean state
 */
@Injectable({
  providedIn: 'root',
})
export class StateCleaner {
  private serverStateService = inject(ServerStateService);
  private applicationStateService = inject(ApplicationStateService);
  private productsStateService = inject(ProductsStateService);

  /**
   * Cleans all application states
   * This should be called before setting new user data during login
   */
  cleanAllStates(): void {
    // Stop any active polling for application status
    // this.applicationStateService.stopPolling();

    // Reset server state
    this.serverStateService.resetState({
      servers: [],
      hasServers: false,
      selectedServer: null,
      providers: {},
      selectedLocation: null,
      selectedProvider: null,
      serverProducts: {},
      isLoaded: false,
      isLoadingProducts: false,
      error: null,
    });

    // Reset application state
    this.applicationStateService.resetState({
      applications: [],
      applicationsLoaded: false,
      selectedApplication: null,
      applicationProducts: [],
      loadingState: 'idle',
      error: null,
    });

    // Reset products state
    this.productsStateService.resetState({
      serverProducts: [],
      applicationProducts: [],
      storageProducts: [],
      isLoadingServerProducts: false,
      isLoadingAppProducts: false,
      isLoadingStorageProducts: false,
      error: null,
    });

    // Note: We don't reset user state or auth state here
    // as they will be updated with new data during login
    // Payment state is cleaned by the UserStateService itself
  }

  /**
   * Cleans only specific states
   * @param states Array of state names to clean ('server', 'application', 'products')
   */
  cleanSpecificStates(states: Array<'server' | 'application' | 'products'>): void {
    states.forEach(state => {
      switch (state) {
        case 'server':
          this.serverStateService.resetState({
            servers: [],
            hasServers: false,
            selectedServer: null,
            providers: {},
            selectedLocation: null,
            selectedProvider: null,
            serverProducts: {},
            isLoaded: false,
            isLoadingProducts: false,
            error: null,
          });
          break;
        case 'application':
          // Stop any active polling for application status
          // this.applicationStateService.stopPolling();

          this.applicationStateService.resetState({
            applications: [],
            applicationsLoaded: false,
            selectedApplication: null,
            applicationProducts: [],
            loadingState: 'idle',
            error: null,
          });
          break;
        case 'products':
          this.productsStateService.resetState({
            serverProducts: [],
            applicationProducts: [],
            storageProducts: [],
            isLoadingServerProducts: false,
            isLoadingAppProducts: false,
            isLoadingStorageProducts: false,
            error: null,
          });
          break;
      }
    });
  }
}
